import { type WebAppRouter, RouterProvider } from '@web/app/provider'
import { persistor, store } from '@web/app/store'
import { config, KitToastProvider, Spinner, TamaguiProvider } from '@kit/ui'
import ReactDOM from 'react-dom/client'
import { useColorScheme } from 'react-native'
import { GestureHandlerRootView } from 'react-native-gesture-handler'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import 'moment/dist/locale/es'
import moment from 'moment'
import { AppThemeProvider } from './app/theme/AppThemeProvider'
moment.locale('es')

// --- ignore sort import ---
import '@tamagui/core/reset.css'
import './style.css'
import './tamagui.css'
import z from 'zod'

declare module '@tanstack/react-router' {
  interface Register {
    router: WebAppRouter
  }
}

function App() {
  const colorScheme = useColorScheme()

  return (
    <TamaguiProvider config={config} defaultTheme="light">
      <AppThemeProvider systemScheme={colorScheme}>
        <GestureHandlerRootView style={{ flex: 1 }}>
          <KitToastProvider
            swipeDirection="horizontal"
            viewportProps={{
              right: '$true',
              bottom: '$6',
            }}
            toastProps={{
              miw: 400,
              p: '$2',
              bordered: true,
              radiused: true,
              animation: 'medium',
              enterStyle: { opacity: 0, x: 75 },
              exitStyle: { opacity: 0, y: 75 },
            }}
          >
            <Provider store={store}>
              <PersistGate loading={<Spinner />} persistor={persistor}>
                <RouterProvider />
              </PersistGate>
            </Provider>
          </KitToastProvider>
        </GestureHandlerRootView>
      </AppThemeProvider>
    </TamaguiProvider>
  )
}

const rootElement = document.getElementById('root')!
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    // <React.StrictMode>
    <App />
    // </React.StrictMode>
  )
}

/**
 * Custom Zod error messages in Spanish
 * a like to: {
    "code": "too_small",
    "minimum": 2,
    "type": "string",
    "inclusive": true,
    "exact": false,
    "path": []
  }
  b like to: {
    "data": "str value"
    "defaultError": "String must contain at least 2 character(s)"
  }
 */
z.setErrorMap((a, b) => {
  switch (a.code) {
    case 'too_small':
      return {
        message: `Al menos ${a.minimum} ${a.type === 'string' ? (a.minimum > 1 ? 'caracteres' : 'carácter') : ''
          }`,
      }
    case 'too_big':
      return {
        message: `No más de ${a.maximum} ${a.type === 'string' ? (a.maximum > 1 ? 'caracteres' : 'carácter') : ''
          }`,
      }
    default:
      return { message: b.defaultError }
  }
})
